export default "__VITE_ASSET__Ct8lSGTh__"